export default "__VITE_ASSET__VRCM4O9P__"